import React from "react";

import { useMediaProps } from "screens/question/hooks";
import { MediaPreview, CameraButton, AudioButton } from "components";
import { Device } from "utils";

import { Container, MediaFiles } from "./styled";

export const MediaQuestion = ({ question }) => {
  const {
    audio,
    photo,
    video,
    onCapture,
    removeFile,
    audioFile,
    mediaFiles,
  } = useMediaProps(question);

  return (
    <Container>
      {question.options.map(() => {
        return (
          <>
            <MediaFiles>
              {mediaFiles.map(file => {
                return (
                  <MediaPreview
                    key={file.id}
                    media={file}
                    remove={() => removeFile(file.id)}
                  />
                );
              })}
            </MediaFiles>
            {(photo || video) && (
              <CameraButton video={video} photo={photo} onCapture={onCapture} />
            )}
            {audio && Device.IS_WEB_AUDIO_SUPPORTED && (
              <AudioButton
                savedClip={audioFile.uri}
                onCapture={onCapture}
                removeFile={() => removeFile(audioFile.id)}
              />
            )}
          </>
        );
      })}
    </Container>
  );
};
